import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Home } from './pages/Home';
import { EventsCalendar } from './pages/EventsCalendar';
import { Gallery } from './pages/Gallery';
import { AfterHours } from './pages/AfterHours';
import { BottleService } from './pages/BottleService';
import { Contact } from './pages/Contact';
import { Dining } from './pages/Dining';
import { CorporateEvents } from './pages/CorporateEvents';
import { Daytime } from './pages/Daytime';
import { Brunch } from './pages/Brunch';
import { Nightlife } from './pages/Nightlife';
import { VipHosts } from './pages/VipHosts';
import { BookRoom } from './pages/BookRoom';
import { Cart } from './pages/Cart';
import { BookNow } from './pages/BookNow';
import { Menu } from './pages/Menu';
import { ScrollToTop } from './components/ScrollToTop';
import { PageTransition } from './components/PageTransition';
import { CartProvider } from './context/CartContext';
function AnimatedRoutes() {
  const location = useLocation();
  return <Routes location={location} key={location.pathname} data-id="element-0">
      <Route path="/" element={<PageTransition data-id="element-2">
            <Home data-id="element-3" />
          </PageTransition>} data-id="element-1" />
      <Route path="/events" element={<PageTransition data-id="element-5">
            <EventsCalendar data-id="element-6" />
          </PageTransition>} data-id="element-4" />
      <Route path="/menu" element={<PageTransition data-id="element-8">
            <Menu data-id="element-9" />
          </PageTransition>} data-id="element-7" />
      <Route path="/gallery" element={<PageTransition data-id="element-11">
            <Gallery data-id="element-12" />
          </PageTransition>} data-id="element-10" />
      <Route path="/after-hours" element={<PageTransition data-id="element-14">
            <AfterHours data-id="element-15" />
          </PageTransition>} data-id="element-13" />
      <Route path="/bottle-service" element={<PageTransition data-id="element-17">
            <BottleService data-id="element-18" />
          </PageTransition>} data-id="element-16" />
      <Route path="/contact" element={<PageTransition data-id="element-20">
            <Contact data-id="element-21" />
          </PageTransition>} data-id="element-19" />
      <Route path="/dining" element={<PageTransition data-id="element-23">
            <Dining data-id="element-24" />
          </PageTransition>} data-id="element-22" />
      <Route path="/corporate-events" element={<PageTransition data-id="element-26">
            <CorporateEvents data-id="element-27" />
          </PageTransition>} data-id="element-25" />
      <Route path="/daytime" element={<PageTransition data-id="element-29">
            <Daytime data-id="element-30" />
          </PageTransition>} data-id="element-28" />
      <Route path="/brunch" element={<PageTransition data-id="element-32">
            <Brunch data-id="element-33" />
          </PageTransition>} data-id="element-31" />
      <Route path="/nightlife" element={<PageTransition data-id="element-35">
            <Nightlife data-id="element-36" />
          </PageTransition>} data-id="element-34" />
      <Route path="/vip-hosts" element={<PageTransition data-id="element-38">
            <VipHosts data-id="element-39" />
          </PageTransition>} data-id="element-37" />
      <Route path="/book-room" element={<PageTransition data-id="element-41">
            <BookRoom data-id="element-42" />
          </PageTransition>} data-id="element-40" />
      <Route path="/cart" element={<PageTransition data-id="element-44">
            <Cart data-id="element-45" />
          </PageTransition>} data-id="element-43" />
      <Route path="/book-now" element={<PageTransition data-id="element-47">
            <BookNow data-id="element-48" />
          </PageTransition>} data-id="element-46" />
    </Routes>;
}
export function App() {
  return <CartProvider data-id="element-49">
      <Router data-id="element-50">
        <ScrollToTop data-id="element-51" />
        <AnimatedRoutes data-id="element-52" />
      </Router>
    </CartProvider>;
}